import React from 'react';
import ReloadButton from '../../../features/ReloadButton/ReloadButton';
import { useTemplate } from '../../../features/template/TemplateProvider';
import Button from '../../../utils/Button';

function ApiAccessKeyHeader({ handleReload }) {
    const { openModal } = useTemplate();
    return (
        <div className="flex justify-between items-center mb-6">
            <h2 className="font-medium text-xl">Access Token</h2>

            <div className="flex items-center gap-2">
                <ReloadButton height="h-10" width="w-10" onClick={handleReload} />
                <Button
                    onClick={() => openModal('create-new-access-token')}
                    title="+ Generate New Token"
                />
            </div>
        </div>
    );
}

export default ApiAccessKeyHeader;
